<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">
          본부별
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            수수료관리 → 본부별
          </div>
        </h5>
        <div>
          <p
            style="
              font-size: 14px;
              line-height: 24px;
              margin-top: 10px;
              color: #246281;
            "
          >
            - 해당 데이터는
            <span style="font-weight: bold">전월 말일 23:50분을 기준</span>으로
            분석된 데이터입니다.<br />
            - 데이터 집계 이후
            <span style="font-weight: bold">변경또는 취소된 아이디의 경우</span>
            해당 데이터에 집계되지 않습니다.
          </p>
        </div>
        <query-grid :config="config" ref="qg">
          <template #items="props">
            <tr v-for="record in props.records" v-bind:key="record.id">
              <td scope="row" style="text-align: center">{{ record.id }}</td>
              <td>{{ record.name }}</td>
              <!--학원-->
              <td>
                {{ parseInt(record.biz.prev_mon_cnt || 0).toLocaleString() }}
              </td>
              <td>
                {{
                  parseInt(record.biz.non_r_bizes.length || 0).toLocaleString()
                }}
              </td>
              <td>
                {{ parseInt(record.biz.non_r_total_pay || 0).toLocaleString() }}
              </td>
              <td>
                {{ parseInt(record.biz.r_bizes.length || 0).toLocaleString() }}
              </td>
              <td>
                {{ parseInt(record.biz.r_total_pay || 0).toLocaleString() }}
              </td>
              <td>
                {{ parseInt(record.biz.sub_total_cnt || 0).toLocaleString() }}
              </td>
              <td>
                {{ parseInt(record.biz.sub_total_pay || 0).toLocaleString() }}
              </td>
              <td>
                {{
                  parseInt(
                    record.biz.non_r_total_pay +
                      record.biz.r_total_pay +
                      record.biz.sub_total_pay
                  ).toLocaleString()
                }}
              </td>
              <td>
                <button
                  type="button"
                  class="mgl10 btn btn-success"
                  data-bs-toggle="modal"
                  data-bs-target=".detail_print"
                  href="#myModal2"
                  @click="selRecord = record"
                >
                  출력
                </button>
              </td>
            </tr>
          </template>
        </query-grid>
      </div>
    </div>

    <div
      class="modal fade detail_print"
      id="myModal2"
      tabindex="-2"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      style="display: none; z-index: 1060"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content" v-if="selRecord">
          <div style="text-align: center">
            <h5>수수료 정산 내역서</h5>
            <p>{{ selRecord.name }}</p>
          </div>
          <table class="table">
            <tbody>
              <tr>
                <th :rowspan="selRecord.biz.non_r_bizes.length + 1">
                  가맹비 수수료
                </th>
                <th>캠퍼스명</th>
                <th>가맹비</th>
                <th>기가맹점수</th>
                <th>수수료율</th>
                <th>금액</th>
                <th>합계</th>
              </tr>
              <tr
                v-for="(campus, i) in selRecord.biz.non_r_bizes"
                :key="campus.id"
              >
                <td>{{ campus.name }}</td>
                <td>{{ campus.price }}</td>
                <td v-if="!i" :rowspan="selRecord.biz.non_r_bizes.length">
                  {{ selRecord.biz.prev_mon_cnt }}
                </td>
                <td>{{ campus.percentage }}%</td>
                <td>{{ campus.pay_price }}</td>
                <td v-if="!i" :rowspan="selRecord.biz.non_r_bizes.length">
                  {{ selRecord.biz.non_r_total_pay }}
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table">
            <tbody>
              <tr>
                <th :rowspan="selRecord.biz.r_bizes.length + 1">
                  재계약비 수수료
                </th>
                <th>캠퍼스명</th>
                <th>재계약비</th>
                <th>연평균 아이디</th>
                <th>수수료율</th>
                <th>금액</th>
                <th>합계</th>
              </tr>
              <tr v-for="(campus, i) in selRecord.biz.r_bizes" :key="campus.id">
                <td>{{ campus.name }}</td>
                <td>{{ campus.price }}</td>
                <td>{{ campus.cnt_sub }}</td>
                <td>{{ campus.percentage }}%</td>
                <td>{{ campus.pay_price }}</td>
                <td v-if="!i" :rowspan="selRecord.biz.r_bizes.length">
                  {{ selRecord.biz.r_total_pay }}
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table">
            <tbody>
              <tr>
                <th :rowspan="selRecord.biz.sub_bizes.length + 1">
                  등록아이디 수수료
                </th>
                <th>캠퍼스명</th>
                <th>아이디수</th>
                <th>적용금액</th>
                <th>수수료율</th>
                <th>금액</th>
                <th>합계</th>
              </tr>
              <tr
                v-for="(campus, i) in selRecord.biz.sub_bizes"
                :key="campus.id"
              >
                <td>{{ campus.name }}</td>
                <td>{{ campus.cnt }}</td>
                <td v-if="!i" :rowspan="selRecord.biz.sub_bizes.length">
                  30,000
                </td>
                <td>{{ campus.percentage }}%</td>
                <td>{{ campus.pay_price }}</td>
                <td v-if="!i" :rowspan="selRecord.biz.sub_bizes.length">
                  {{ selRecord.biz.sub_total_pay }}
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table">
            <tr>
              <th>수수료 합계</th>
              <th>세금(3.3%)</th>
              <th>지급예정액</th>
            </tr>
            <tr>
              <td>
                {{
                  selRecord.biz.non_r_total_pay +
                  selRecord.biz.r_total_pay +
                  selRecord.biz.sub_total_pay
                }}
              </td>
              <td>
                {{
                  (selRecord.biz.non_r_total_pay +
                    selRecord.biz.r_total_pay +
                    selRecord.biz.sub_total_pay) *
                  0.033
                }}
              </td>
              <td>
                {{
                  (selRecord.biz.non_r_total_pay +
                    selRecord.biz.r_total_pay +
                    selRecord.biz.sub_total_pay) *
                  0.967
                }}
              </td>
            </tr>
          </table>
          <div class="flex_center">
            <button @click="printIt()" class="btn btn-primary">출력</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
import Tree from "../components/Tree";
import axios from "axios";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid";
import treeBtn from "../components/treeBtn";
// @ is an alias to /src

export default {
  name: "Home",
  components: {
    Tree,
    treeBtn,
    Business,
    QueryGrid,
  },
  mounted() {
    var d = new Date();
    this.date_filter_start =
      d.getFullYear() + "-" + d.getMonth().toString().padStart(2, "0") + "-01";
    this.date_filter_end =
      d.getFullYear() + "-" + d.getMonth().toString().padStart(2, "0") + "-31";

    this.search();
  },
  methods: {
    async search() {
      var response = await axios.get(
        "/financials/local/statics?start_date=" +
          this.date_filter_start +
          "&end_date=" +
          this.date_filter_end
      );
      if (response.data.error) {
        $.notify(
          {
            // options
            message: "데이터를 조회할 수 없습니다. " + response.data.error,
          },
          {
            // settings
            type: "danger",
            z_index: 9999,
          }
        );
      } else {
        this.records = response.data.result;
        return response.data.result;
      }
    },
    selectedSearchBiz(biz) {
      console.log(biz);
      this.searchBiz = biz;
      this.search(true);
    },
  },
  data() {
    return {
      records: [],
      selRecord: null,
      date_filter_start: "2022-03-01",
      date_filter_end: "2022-03-01",
      loading: false,
      searchBiz: [],
      config: {
        name: "본부 수수료 정산",
        req_endpoint: "/financials/local/statics",
        default_limit: 20,
        search_fields: [
          {
            id: "businesses",
            name: "표시대상",
            type: "business", // business, date, datetime,
          },
          {
            id: "ym",
            name: "기간",
            type: "month", // business, date, datetime,
          },
        ],
        columns: [
          {
            id: "id",
            sortable: true,
            name: "#",
            excel_print: (v) => {
              return v.id;
            },
          },
          {
            id: "name",
            sortable: true,
            name: "본부명",
            excel_print: (v) => {
              return v.name;
            },
          },
          {
            id: "prev_mon_cnt",
            name: "기가맹점",
            excel_print: (v) => {
              return v.biz.prev_mon_cnt;
            },
          },
          {
            id: "non_r_biz_cnt",
            name: "신규가맹점",
            excel_print: (v) => {
              return v.biz.non_r_bizes.length;
            },
          },
          {
            id: "non_r_biz_pay",
            name: "가맹수수료",
            excel_print: (v) => {
              return v.biz.non_r_total_pay;
            },
          },
          {
            id: "r_biz_cnt",
            name: "재계약",
            excel_print: (v) => {
              return v.biz.r_bizes.length;
            },
          },
          {
            id: "r_biz_pay",
            name: "재계약 수수료",
            excel_print: (v) => {
              return v.biz.r_total_pay;
            },
          },
          {
            id: "sub_biz_cnt",
            name: "아이디",
            excel_print: (v) => {
              return v.biz.sub_total_cnt;
            },
          },
          {
            id: "sub_biz_pay",
            name: "아이디 수수료",
            excel_print: (v) => {
              return v.biz.sub_total_pay;
            },
          },

          {
            id: "total",
            sortable: true,
            name: "총 지급액",
            excel_print: (v) => {
              return (
                v.biz.sub_total_pay + v.biz.r_total_pay + v.biz.non_r_total_pay
              );
            },
          },
          {
            id: "fee_print",
            name: "수수료내역서",
          },
        ],
      },
    };
  },
};
</script>
